export default "__VITE_ASSET__af033853__"